import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";

const VanFacility = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
        AOS.init({ duration: 1000 });
    }, []);
    return (
        <div className="container mx-auto px-6 py-12">
            {/* Heading */}
            <h1 className="text-3xl font-bold text-center mb-6">VAN FACILITY</h1>


            <div className="w-full" data-aos="fade-up">
                <p className="text-lg  text-gray-700 leading-relaxed">
                    Our school provides a safe and reliable van facility to ensure comfortable transportation for students. The vans are well-maintained, equipped with safety features, and driven by trained professionals. We prioritize punctuality and security, making sure students reach school and home on time with utmost care.
                </p>

                <ul className="list-disc list-inside text-gray-700 mt-4">
                    <li>Safe and reliable transportation</li>
                    <li>Well-maintained vans with safety features</li>
                    <li>Experienced and trained drivers</li>
                    <li>Punctual pickup and drop services</li>
                    <li>Comfortable and hassle-free travel for students</li>
                </ul>
            </div>



            {/* Image Grid */}
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-4 mt-8" data-aos="fade-up">
                <img src="https://img.freepik.com/free-vector/school-background-design_1308-171.jpg?ga=GA1.1.736731524.1738591350&semt=ais_hybrid" alt="Smart Classroom 1" className="w-full h-48 object-cover rounded-lg shadow-md" />
                <img src="https://img.freepik.com/free-vector/school-background-design_1308-171.jpg?ga=GA1.1.736731524.1738591350&semt=ais_hybrid" alt="Smart Classroom 2" className="w-full h-48 object-cover rounded-lg shadow-md" />
                <img src="https://img.freepik.com/free-vector/school-background-design_1308-171.jpg?ga=GA1.1.736731524.1738591350&semt=ais_hybrid" alt="Smart Classroom 3" className="w-full h-48 object-cover rounded-lg shadow-md" />
                <img src="https://img.freepik.com/free-vector/school-background-design_1308-171.jpg?ga=GA1.1.736731524.1738591350&semt=ais_hybrid" alt="Smart Classroom 4" className="w-full h-48 object-cover rounded-lg shadow-md" />
            </div>
        </div>
    );
}

export default VanFacility;





